import React from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { emailReg } from 'utils/validators';
import { StyledInput, MandatoryFieldLabel, ErrorField, Field, StyledSubmitField, StyledForm } from './ManageVoucher.styles';

const SearchVoucherByEmailForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <MandatoryFieldLabel htmlFor="recipientEmail">
          <FormattedMessage id="vouchers.recipientEmail" />
        </MandatoryFieldLabel>
        <StyledInput
          {...register('recipientEmail', {
            required: true,
            pattern: emailReg
          })}
          type="text"
          id="recipientEmail"
          validationState={errors.recipientEmail ? 'error' : ''}
        />
        {errors.recipientEmail && (
          <ErrorField id="error-recipient-email">
            <FormattedMessage id="validators.invalidEmail" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="recipient-email-search" type="submit" disabled={!formState.isValid}>
          <FormattedMessage id="vouchers.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchVoucherByEmailForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchVoucherByEmailForm;
